import { render, staticRenderFns } from "./termsGold.vue?vue&type=template&id=029a88b8"
import script from "./termsGold.vue?vue&type=script&lang=js"
export * from "./termsGold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports